<template>
    <div class="container-fluid" v-if="Object.keys(addition).length">
        <hr>
        <div class="row">
            <div class="col">
                <div class="form-group mb-1">
                    <label class="mb-0">{{ $t('Name') }}</label>
                    <p class="custom-gray-input-bg">{{ addition.name[locale] }}</p>
                </div>
            </div>
            <div class="col">
                <div class="form-group mb-1">
                    <label class="mb-0">{{ $t('Comments') }}</label>
                    <p class="custom-gray-input-bg">{{ addition.comments[locale] }}</p>
                </div>
            </div>
        </div>
        <div v-if="addition.dbname" class="row mt-3">
            <div class="col">
                <div class="float-left" style="position: relative">
                    <span class="mdi mdi-24px mdi-trash-can-outline trash-img" @click="destroyImg"/>
                    <img :src="`${envUrl}/additions/${addition.dbname}`"
                         width="160px"
                         height="auto"
                         class="img-thumbnail"/>
                    <p>{{ addition.filename | truncate }}</p>
                </div>
            </div>
        </div>
        <div class="row" v-if="addition.pricelists.length && $store.getters.canEditPrices">
            <div class="col">
                <h4>{{ $t('Prices') }}</h4>
                <app-pricelist v-for="(pricelist, i) in addition.pricelists" :pricelist="pricelist" :key="i"/>
            </div>
        </div>
    </div>
</template>

<script>
import AdditionService from '@services/addition.service';
import {mapGetters} from 'vuex';

export default {
    data() {
        return {
            addition: {}
        };
    },
    computed: {
        ...mapGetters(['envUrl', 'locale'])
    },
    methods: {
        getAddition(additionId) {
            AdditionService.show(additionId).then(res => this.addition = res);
        },
        destroyImg(imgId, index) {
            if(!window.confirm(`${this.$t('Delete')}?`)) {
                return false;
            }
            AdditionService.destroyImg(this.addition_id).then(res => {
                this.addition = res;
            });
        },
    },
    created() {
        this.getAddition(this.$route.params.addition_id);
    }
};
</script>
